import { render, staticRenderFns } from "./TaskFolders.vue?vue&type=template&id=2cab895a&scoped=true&"
import script from "./TaskFolders.vue?vue&type=script&lang=js&"
export * from "./TaskFolders.vue?vue&type=script&lang=js&"
import style0 from "./TaskFolders.vue?vue&type=style&index=0&id=2cab895a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab895a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle})
